import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { StateLoadingSkeleton } from "@/components/common/StateLoadingSkeleton";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireTenant?: boolean;
}

export function ProtectedRoute({ children, requireTenant = true }: ProtectedRouteProps) {
  const { user, isLoading, isDataLoaded, hasTenant, isActive, mustChangePassword, currentRole } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center p-8">
        <StateLoadingSkeleton variant="page" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isDataLoaded) {
    return (
      <div className="flex min-h-screen items-center justify-center p-8">
        <StateLoadingSkeleton variant="page" />
      </div>
    );
  }

  if (mustChangePassword && location.pathname !== "/reset-password") {
    return <Navigate to="/reset-password" replace />;
  }

  if (requireTenant && hasTenant && isActive === false) {
    return <Navigate to="/acesso-bloqueado" replace />;
  }

  if (requireTenant && !hasTenant && location.pathname !== "/app/onboarding") {
    return <Navigate to="/app/onboarding" replace />;
  }

  // Role-based redirect: field workers go to their dedicated field app
  if (requireTenant && hasTenant && isActive !== false) {
    const isFieldRoute = location.pathname.startsWith("/app/campo");
    const isMainApp = location.pathname === "/app" || (location.pathname.startsWith("/app/") && !location.pathname.startsWith("/app/campo") && !location.pathname.startsWith("/app/onboarding"));

    if (currentRole === "entregador" && isMainApp) {
      return <Navigate to="/app/campo/logistica" replace />;
    }
    if (currentRole === "instalador" && isMainApp) {
      return <Navigate to="/app/campo/instalador" replace />;
    }
  }

  return <>{children}</>;
}
